import WRAP from "WRAP-JS";
import { WX_ID_SS_SCALE } from "../../../store/WeatherContentsState";
import { formatUTCDate, parseUTCDate, _orderBy } from "../../../utils/FPEUtils";
import TimeController from "../helper/TimeController";
import LegendSsScale from "../legend/LegendSsScale";
import {
  dhConfig1000hPa,
  dhConfig975hPa,
  dhConfig950hPa,
  dhConfig925hPa,
  dhConfig900hPa,
  dhConfig850hPa,
  dhConfig800hPa,
  dhConfig700hPa,
  dhConfig600hPa,
  dhConfig500hPa,
  dhConfig400hPa,
  dhConfig300hPa,
  layerConfigSsScale
} from "./config/ConfigSsScale";
import MissingDataObserver from "../helper/MissingDataObserver";
import { COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER } from "../../../constants/ErrorMessage";

export const SS_SCALE_1000 = 'SS_SCALE_1000';
export const SS_SCALE_975 = 'SS_SCALE_975';
export const SS_SCALE_950 = 'SS_SCALE_950';
export const SS_SCALE_925 = 'SS_SCALE_925';
export const SS_SCALE_900 = 'SS_SCALE_900';
export const SS_SCALE_850 = 'SS_SCALE_850';
export const SS_SCALE_800 = 'SS_SCALE_800';
export const SS_SCALE_700 = 'SS_SCALE_700';
export const SS_SCALE_600 = 'SS_SCALE_600';
export const SS_SCALE_500 = 'SS_SCALE_500';
export const SS_SCALE_400 = 'SS_SCALE_400';
export const SS_SCALE_300 = 'SS_SCALE_300';

const SS_SCALE_LEVEL = {
  [SS_SCALE_300]: "FL300 / 300hPa",
  [SS_SCALE_400]: "FL240 / 400hPa",
  [SS_SCALE_500]: "FL180 / 500hPa",
  [SS_SCALE_600]: "FL140 / 600hPa",
  [SS_SCALE_700]: "FL100 / 700hPa",
  [SS_SCALE_800]: "FL070 / 800hPa",
  [SS_SCALE_850]: "FL050 / 850hPa",
  [SS_SCALE_900]: "FL030 / 900hPa",
  [SS_SCALE_925]: "FL025 / 925hPa",
  [SS_SCALE_950]: "FL020 / 950hPa",
  [SS_SCALE_975]: "FL010 / 975hPa",
  [SS_SCALE_1000]: "FL005 / 1000hPa",
};

const MISSING_THRESHOLD = {
  [SS_SCALE_1000]: 0,
  [SS_SCALE_975]: 0,
  [SS_SCALE_950]: 0,
  [SS_SCALE_925]: 0,
  [SS_SCALE_900]: 0,
  [SS_SCALE_850]: 0,
  [SS_SCALE_800]: 0,
  [SS_SCALE_700]: 0,
  [SS_SCALE_600]: 0,
  [SS_SCALE_500]: 0,
  [SS_SCALE_400]: 0,
  [SS_SCALE_300]: 0
};

class SsScale {
  static NAME = WX_ID_SS_SCALE;

  // layer
  layer1000;
  layer975;
  layer950;
  layer925;
  layer900;
  layer850;
  layer800;
  layer700;
  layer600;
  layer500;
  layer400;
  layer300;
  // dh
  dh1000;
  dh975;
  dh950;
  dh925;
  dh900;
  dh850;
  dh800;
  dh700;
  dh600;
  dh500;
  dh400;
  dh300;

  dhAutoUpdate = {
    [SS_SCALE_1000]: true,
    [SS_SCALE_975]: true,
    [SS_SCALE_950]: true,
    [SS_SCALE_925]: true,
    [SS_SCALE_900]: true,
    [SS_SCALE_850]: true,
    [SS_SCALE_800]: true,
    [SS_SCALE_700]: true,
    [SS_SCALE_600]: true,
    [SS_SCALE_500]: true,
    [SS_SCALE_400]: true,
    [SS_SCALE_300]: true
  }
  levelInitialize = {
    [SS_SCALE_1000]: false,
    [SS_SCALE_975]: false,
    [SS_SCALE_950]: false,
    [SS_SCALE_925]: false,
    [SS_SCALE_900]: false,
    [SS_SCALE_850]: false,
    [SS_SCALE_800]: false,
    [SS_SCALE_700]: false,
    [SS_SCALE_600]: false,
    [SS_SCALE_500]: false,
    [SS_SCALE_400]: false,
    [SS_SCALE_300]: false
  }
  levelValidtimeInfo = {
    [SS_SCALE_1000]: '---',
    [SS_SCALE_975]: '---',
    [SS_SCALE_950]: '---',
    [SS_SCALE_925]: '---',
    [SS_SCALE_900]: '---',
    [SS_SCALE_850]: '---',
    [SS_SCALE_800]: '---',
    [SS_SCALE_700]: '---',
    [SS_SCALE_600]: '---',
    [SS_SCALE_500]: '---',
    [SS_SCALE_400]: '---',
    [SS_SCALE_300]: '---'
  }
  levelVisible = {
    [SS_SCALE_1000]: false,
    [SS_SCALE_975]: false,
    [SS_SCALE_950]: false,
    [SS_SCALE_925]: false,
    [SS_SCALE_900]: false,
    [SS_SCALE_850]: false,
    [SS_SCALE_800]: false,
    [SS_SCALE_700]: false,
    [SS_SCALE_600]: false,
    [SS_SCALE_500]: false,
    [SS_SCALE_400]: false,
    [SS_SCALE_300]: false
  }

  // タイムコントローラ
  ssScaleTimeController;
  // タイムコントローラのリスト
  timeList;
  // 自動更新フラグ
  autoRefresh = true;

  ready = false;
  etd;
  elapsed = 0;
  dispatcher;
  visible = false;
  level = SS_SCALE_850;
  errorMessageInfo = {};

  constructor() {
    this.layer1000 = new WRAP.Geo.Layer(SS_SCALE_1000);
    this.layer975 = new WRAP.Geo.Layer(SS_SCALE_975);
    this.layer950 = new WRAP.Geo.Layer(SS_SCALE_950);
    this.layer925 = new WRAP.Geo.Layer(SS_SCALE_925);
    this.layer900 = new WRAP.Geo.Layer(SS_SCALE_900);
    this.layer850 = new WRAP.Geo.Layer(SS_SCALE_850);
    this.layer800 = new WRAP.Geo.Layer(SS_SCALE_800);
    this.layer700 = new WRAP.Geo.Layer(SS_SCALE_700);
    this.layer600 = new WRAP.Geo.Layer(SS_SCALE_600);
    this.layer500 = new WRAP.Geo.Layer(SS_SCALE_500);
    this.layer400 = new WRAP.Geo.Layer(SS_SCALE_400);
    this.layer300 = new WRAP.Geo.Layer(SS_SCALE_300);
    this.layer1000.setVisible(false);
    this.layer975.setVisible(false);
    this.layer950.setVisible(false);
    this.layer925.setVisible(false);
    this.layer900.setVisible(false);
    this.layer850.setVisible(false);
    this.layer800.setVisible(false);
    this.layer700.setVisible(false);
    this.layer600.setVisible(false);
    this.layer500.setVisible(false);
    this.layer400.setVisible(false);
    this.layer300.setVisible(false);
    this.layer1000.disableInteraction(true);
    this.layer975.disableInteraction(true);
    this.layer950.disableInteraction(true);
    this.layer925.disableInteraction(true);
    this.layer900.disableInteraction(true);
    this.layer850.disableInteraction(true);
    this.layer800.disableInteraction(true);
    this.layer700.disableInteraction(true);
    this.layer600.disableInteraction(true);
    this.layer500.disableInteraction(true);
    this.layer400.disableInteraction(true);
    this.layer300.disableInteraction(true);

    this.ssScaleTimeController = new TimeController(WX_ID_SS_SCALE, {
      label: 'SS Scale',
      getTimeList: () => {
        if (this.timeList) {
          return this.timeList;
        }
        this._updateTimeList();
        return this.timeList;
      },
      updated: () => {
        this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
      },
      changeAutoRefresh: (autoFlg) => {
        this.setAutoRefresh(autoFlg);
      }
    });
  }

  setDispatcher(dispatcher) {
    this.dispatcher = dispatcher;
    this.missingDataObserver = new MissingDataObserver(this.dispatcher, MISSING_THRESHOLD, this.levelVisible);
  }

  async initialize() {
    await this.initData();
    this.initLayer();
    this.initTimeController();
    this.levelInitialize[this.level] = true;
  }

  initData() {
    return new Promise(resolve => {
      let dh;
      switch(this.level) {
        case SS_SCALE_1000:
          dh = this.dh1000 = new WRAP.Data(dhConfig1000hPa);
          this.missingDataObserver.monitoring(SS_SCALE_1000, this.dh1000, this.layer1000);
          break;
        case SS_SCALE_975:
          dh = this.dh975 = new WRAP.Data(dhConfig975hPa);
          this.missingDataObserver.monitoring(SS_SCALE_975, this.dh975, this.layer975);
          break;
        case SS_SCALE_950:
          dh = this.dh950 = new WRAP.Data(dhConfig950hPa);
          this.missingDataObserver.monitoring(SS_SCALE_950, this.dh950, this.layer950);
          break;
        case SS_SCALE_925:
          dh = this.dh925 = new WRAP.Data(dhConfig925hPa);
          this.missingDataObserver.monitoring(SS_SCALE_925, this.dh925, this.layer925);
          break;
        case SS_SCALE_900:
          dh = this.dh900 = new WRAP.Data(dhConfig900hPa);
          this.missingDataObserver.monitoring(SS_SCALE_900, this.dh900, this.layer900);
          break;
        case SS_SCALE_850:
          dh = this.dh850 = new WRAP.Data(dhConfig850hPa);
          this.missingDataObserver.monitoring(SS_SCALE_850, this.dh850, this.layer850);
          break;
        case SS_SCALE_800:
          dh = this.dh800 = new WRAP.Data(dhConfig800hPa);
          this.missingDataObserver.monitoring(SS_SCALE_800, this.dh800, this.layer800);
          break;
        case SS_SCALE_700:
          dh = this.dh700 = new WRAP.Data(dhConfig700hPa);
          this.missingDataObserver.monitoring(SS_SCALE_700, this.dh700, this.layer700);
          break;
        case SS_SCALE_600:
          dh = this.dh600 = new WRAP.Data(dhConfig600hPa);
          this.missingDataObserver.monitoring(SS_SCALE_600, this.dh600, this.layer600);
          break;
        case SS_SCALE_500:
          dh = this.dh500 = new WRAP.Data(dhConfig500hPa);
          this.missingDataObserver.monitoring(SS_SCALE_500, this.dh500, this.layer500);
          break;
        case SS_SCALE_400:
          dh = this.dh400 = new WRAP.Data(dhConfig400hPa);
          this.missingDataObserver.monitoring(SS_SCALE_400, this.dh400, this.layer400);
          break;
        case SS_SCALE_300:
          dh = this.dh300 = new WRAP.Data(dhConfig300hPa);
          this.missingDataObserver.monitoring(SS_SCALE_300, this.dh300, this.layer300);
          break;
        default:
          break;
      }
      dh.validate((displayTime, data, content) => {
        return this._validateTime(data, displayTime, content);
      });
      dh.updated('validtime', ref => {
        this._selectValidTime(ref);
        resolve(ref);
      });
      dh.updated('timelist', () => {
        if (this.errorMessageInfo[this.level]) {
          this.dispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo[this.level]});
          this.errorMessageInfo[this.level] = null;
        }
      }, () => {
        this.errorMessageInfo[this.level] = this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: `${dh.conf.data.Name} timelist`,
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
        }});
      });
    });
  }

  initLayer() {
    const target = this._getTarget();
    target.layer.configure(target.dh, layerConfigSsScale);
  }

  initTimeController() {
    const target = this._getTarget();
    this.ssScaleTimeController.addLayer(target.layer);
  }

  async setLevel(level) {
    //現在選択中のautoUpdateをfalseに切り替える
    if (this.level !== level && this.levelInitialize[this.level]) {
      const target = this._getTarget();
      target.dh.setAutoUpdate('validtime', false);
      this.dhAutoUpdate[this.level] = false;
    }
    this.level = level;
    /*
     Contents Set対応
     setLevelの処理後、drawLayerを呼び出さないと画面に反映されない。
     対応前はMenuでsetLevel後にdrawLayerを呼び出していた。
     それだとContentsSetを適用させた際にdrawLayerが呼び出されないためここでコールするように修正
     visible=falseの場合はContentsSet適用の処理からdrawLayerが呼ばれるためここではvisibleがtrueの場合に呼び出す対応を入れる
     */
    if (this.visible === true) {
      await this.drawLayer(true);
    }
  }

  getLevel() {
    return this.level;
  }

  getLevels() {
    return [
      SS_SCALE_300,
      SS_SCALE_400,
      SS_SCALE_500,
      SS_SCALE_600,
      SS_SCALE_700,
      SS_SCALE_800,
      SS_SCALE_850,
      SS_SCALE_900,
      SS_SCALE_925,
      SS_SCALE_950,
      SS_SCALE_975,
      SS_SCALE_1000
    ].map(value => {
      return {
        value,
        label: SS_SCALE_LEVEL[value]
      };
    });
  }

  async drawLayer(visible) {
    this.visible = visible;

    if (!this.levelInitialize[this.level]) {
      await this.initialize();
    }

    this.setVisible(visible);
  }

  getLayer() {
    return this._allLayers();
  }

  _allLayers() {
    return [
      this.layer1000,
      this.layer975,
      this.layer950,
      this.layer925,
      this.layer900,
      this.layer850,
      this.layer800,
      this.layer700,
      this.layer600,
      this.layer500,
      this.layer400,
      this.layer300
    ]
  }

  setVisible(visible) {
    if (!this.levelInitialize[this.level]) {
      return;
    }

    this._updateVisibleInfo(this.level, visible);

    const target = this._getTarget();

    if (target.layer.visible() === visible) {
      return;
    }

    this._allLayers().forEach(layer => {
      if (layer._name === this.level) {
        if (visible) {
          layer.show();
        } else {
          layer.hide();
        }
      } else {
        layer.hide();
      }
    });

    const enabled = visible && this.autoRefresh;
    if (target.autoUpdate !== enabled) {
      target.dh.setAutoUpdate('validtime', enabled);
      this.dhAutoUpdate[this.level] = enabled;
    }

    this._updateTimeList();
    this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
  }

  getTimeInformation() {
    return {
      id: SsScale.NAME,
      label: `SS Scale ${SS_SCALE_LEVEL[this.level].replace(/\s+/g,'')}`,
      baseTime: {
        id: this.level,
        time: this.levelValidtimeInfo[this.level]
      },
    }
  }

  getLegend() {
    return {
      id: SsScale.NAME,
      label: 'SS Scale',
      component: LegendSsScale,
      contents: this
    }
  }

  getTimeController() {
    return this.ssScaleTimeController;
  }

  applyElapsed(elapsed) {
    this.elapsed = elapsed;

    if (!this.levelInitialize[this.level]) return;

    const target = this._getTarget();
    this._selectValidTime(target.dh.retained.validtime);
  }

  applyPlanETD(etd) {
    this.etd = etd;

    if (!this.levelInitialize[this.level]) return;

    const target = this._getTarget();
    this._selectValidTime(target.dh.retained.validtime);
  }

  setAutoRefresh(autoFlg) {
    if (autoFlg === this.autoRefresh) return;

    this.autoRefresh = autoFlg;

    if (!this.levelInitialize[this.level]) return;

    const target = this._getTarget();
    if (this.dhAutoUpdate[this.level] !== this.autoRefresh) {
      target.dh.setAutoUpdate('validtime', this.autoRefresh);
      this.dhAutoUpdate[this.level] = this.autoRefresh;
    }
  }

  /**
   * 自動更新モード時のvalid選択
   */
  _selectValidTime(ref) {
    let targetTime;
    if (!this.etd) {
      //プラン未選択時
      if (!this.autoRefresh) {
        targetTime = this.ssScaleTimeController.getCurrentTime();
      } else {
        targetTime = Date.now();
      }
    } else {
      //プラン選択時
      targetTime = this.etd.getTime() + this.elapsed * 1000;
    }

    const vt = this._nearValidTime(ref, targetTime);
    if (vt) {
      if (this.levelValidtimeInfo[this.level] !== vt) {
        this.levelValidtimeInfo[this.level] = vt;
        this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
      }
      this._updateDataset();
    }
    this._updateTimeList();
  }

  /**
   * タイムコントロールモード時のvalid選択
   */
  _validateTime(data, displayTime, content) {
    const vt = this._nearValidTime(data.retained.validtime, displayTime);
    if (vt) {
      this.levelValidtimeInfo[this.level] = content.validtime = vt;
      return true;
    }
    return false
  }

  _nearValidTime(timeList, targetTime) {
    if (!timeList || timeList.validtime.length === 0) return null;
    timeList = timeList.validtime;

    let _targetTime;
    if (typeof targetTime === 'number') {
      _targetTime = targetTime
    } else {
      _targetTime = parseUTCDate(targetTime).getTime();
    }

    const tmpTimeList = timeList.reduce((accumulator, validtime) => {
      const validSec = parseUTCDate(validtime).getTime();
      accumulator.push(
        {
          "validtime": validtime,
          "validtime_msec": validSec
        }
      );
      return accumulator;
    }, []);

    this.latestValid = tmpTimeList[0].validtime;

    // targetTimeに最も近いvalidを選択する(直近が過去時制と未来時制で同時刻の場合、未来時制のValidデータを採用する。)
    const sortedTimelist = _orderBy(tmpTimeList, [
      o => {
        return Math.abs(_targetTime - o.validtime_msec);
      },
      'validtime'
    ], ['asc', 'desc']);

    const selectedTime = sortedTimelist[0];

    return selectedTime.validtime;
  }

  _updateDataset() {
    if (this.levelValidtimeInfo[this.level] !== '---') {
      /**
       * WRAP, CloudFrontのキャッシュ対策としてクエリストリングに最新のvalidtimeを付与する
       * timelistが更新された場合にvalidtimeを更新する
       */
      let latestValid;
      if (this.timeList && this.timeList[this.timeList.length - 1] !== this.latestValid) {
        latestValid = this.latestValid;
      } else {
        latestValid = this.levelValidtimeInfo[this.level];
      }
      const target = this._getTarget();
      target.layer.set({validtime: this.levelValidtimeInfo[this.level], latestValid: latestValid});
    }
  }

  _updateTimeList() {
    const target = this._getTarget();
    let validTimes = target.dh?.retained?.validtime?.validtime;
    if (!validTimes) {
      return;
    }

    // 最新から直近過去までのvalidにfilter
    const now = new Date();
    now.setMinutes(0, 0, 0);
    const base = formatUTCDate(now, "%Y%m%dT%H%M%S");
    validTimes = Array.from(validTimes).sort();
    this.timeList = validTimes.filter(vt => {
      return base <= vt;
    });

    if (this.autoRefresh) {
      this.ssScaleTimeController.setCurrentTime(this.levelValidtimeInfo[this.level]);
    }
    this.ssScaleTimeController.adjustCurrentTime();
    this.ssScaleTimeController.invalidate();
  }

  _getTarget() {
    let dh;
    let layer;
    switch(this.level) {
      case SS_SCALE_1000:
        dh = this.dh1000;
        layer = this.layer1000;
        break;
      case SS_SCALE_975:
        dh = this.dh975;
        layer = this.layer975;
        break;
      case SS_SCALE_950:
        dh = this.dh950;
        layer = this.layer950;
        break;
      case SS_SCALE_925:
        dh = this.dh925;
        layer = this.layer925;
        break;
      case SS_SCALE_900:
        dh = this.dh900;
        layer = this.layer900;
        break;
      case SS_SCALE_850:
        dh = this.dh850;
        layer = this.layer850;
        break;
      case SS_SCALE_800:
        dh = this.dh800;
        layer = this.layer800;
        break;
      case SS_SCALE_700:
        dh = this.dh700;
        layer = this.layer700;
        break;
      case SS_SCALE_600:
        dh = this.dh600;
        layer = this.layer600;
        break;
      case SS_SCALE_500:
        dh = this.dh500;
        layer = this.layer500;
        break;
      case SS_SCALE_400:
        dh = this.dh400;
        layer = this.layer400;
        break;
      case SS_SCALE_300:
        dh = this.dh300;
        layer = this.layer300;
        break;
      default:
        break;
    }
    return {
      dh: dh,
      layer: layer,
      autoUpdate: this.dhAutoUpdate[this.level]
    }
  }

  _updateVisibleInfo(type, visible) {
    Object.keys(this.levelVisible).forEach(visibleKey => {
      if (type === visibleKey) {
        if (this.levelVisible[visibleKey] !== visible) {
          this.levelVisible[visibleKey] = visible;
        }
      } else {
        if (this.levelVisible[visibleKey] !== false) {
          this.levelVisible[visibleKey] = false;
        }
      }
    });
  }
}

export default SsScale;
